import { FC, MouseEventHandler, SVGProps } from "react";

export enum UserStatus {
  Available = "Available",
  AvailableIdle = "AvailableIdle",
  Away = "Away",
  BeRightBack = "BeRightBack",
  Busy = "Busy",
  BusyIdle = "BusyIdle",
  DoNotDisturb = "DoNotDisturb",
  Offline = "Offline",
  PresenceUnknown = "PresenceUnknown",
}

export interface UserAvatarProps {
  name?: string;
  surname?: string;
  source?: string;
  className?: string;
  size?: number;
  hasBorder?: boolean;
  status?: UserStatus;
  statusSize?: number;
  onClick?: MouseEventHandler<HTMLDivElement>;
  onlyIcon?: FC<SVGProps<SVGSVGElement>>;
}
